/****************************************************
 * Module Name:  kapanlosslistModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Container, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { v4 as uuidv4 } from "uuid";
import PacketHistoryModal from "../common/packetHistoryModal";
import "./../../style/modalstyle.css";
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import logo from '../../images/pansuriya.jpg'
import CommonSnackbar from "../common/commonSnackBar";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";


const KapanlosslistModal = ({ user, time, kapan, kapanId, userid, close, show, fromdate, todate }) => {
    const [data, setData] = useState([]);
    const [detailLoader, setDetailLoader] = useState(false);
    const [packetId, setPacketId] = useState("");
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [kapanid, setKapanId] = useState("");
    const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
    const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);

    useEffect(() => {
        handleSearch();
    }, []);

    const handleSearch = () => {
        setDetailLoader(true);
        if (user) {
            let data = {
                from: fromdate,
                to: todate,
                responsibleuserid: userid
            }
            ReportProxy.GetLossBySingleUserid(
                data,
                (response) => {
                    if (response) {
                        let data = response
                        for (let i = 0; i < data.length; i++) {
                            data[i].id = uuidv4();
                        }
                        setData(data);
                        setDetailLoader(false)
                    } else {
                        setErrorSnackbar(true)
                        setDetailLoader(false)
                    }
                }
            );
        } else if (time) {
            let data = {
                from: fromdate,
                to: todate,
                kapanid: kapanId
            }
            ReportProxy.GetSingleLossByKapanTimeWise(
                data,
                (response) => {
                    if (response) {
                        let data = response
                        for (let i = 0; i < data.length; i++) {
                            data[i].id = uuidv4();
                        }
                        setData(data);
                        setDetailLoader(false)
                    } else {
                        setErrorSnackbar(true)
                        setDetailLoader(false)
                    }
                }
            );
        } else {
            let kapanId = [kapan]
            ReportProxy.GetLossByKapanId(
                kapanId,
                (response) => {
                    if (response) {
                        let data = response
                        for (let i = 0; i < data.length; i++) {
                            data[i].id = uuidv4();
                        }
                        setData(data);
                        setDetailLoader(false)
                    } else {
                        setErrorSnackbar(true)
                        setDetailLoader(false)
                    }
                }
            );
        }

    };

    const handlePacketDetailModal = (params, kapanid) => {
        setPacketId(params);
        setKapanId(kapanid);
        setShowPacketDetailModal(true);
    };

    const columnName = [
        {
            field: "kapanid",
            headerName: "KAPANID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => {
                        setKapanId(params.row.kapanid);
                        setShowKapanDetailModal(true);
                    }}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
            width: 80,
        },
        {
            field: "packetid",
            headerName: "PACKETID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: (params) => (Utility.NeedToShowPacketDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handlePacketDetailModal(params.value, params.row.kapanid)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "responsibleuserid",
            headerName: "RESPONSIBLE USER ID",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "reportedbyuser",
            headerName: "REPORTED BY USER",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "weightloss",
            headerName: "WEIGHT LOSS",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "loss",
            headerName: "LOSS",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "losscategoryid",
            headerName: "LOSS CATEGORY ID",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
        },
        {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value)
        },
        {
            field: "remark",
            headerName: "REMARK",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 100,
        },
    ];

    const rows = data;
    const columns = user ?
        columnName.filter(
            (col) => col.field !== "responsibleuserid"
        ) : columnName
    return (
        <div>
            <CommonSnackbar
                show={errorSnackbar}
                message={<Box>{Constants.APiFailErrorMessage}</Box>}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                handleClose={() => setErrorSnackbar(false)}
                title="Failed"
            />
            {showPacketDetailModal ? (
                <PacketHistoryModal
                    show={showPacketDetailModal}
                    packetId={packetId}
                    kapanId={kapanid}
                    close={() => setShowPacketDetailModal(false)}
                />
            ) : null}
            {showKapanDetailModal ? (
                <KapanHistoryModal
                    show={showKapanDetailModal}
                    kapanId={kapanid}
                    close={() => setShowKapanDetailModal(false)}
                />
            ) : null}
            <Modal show={show} onHide={close} dialogClassName="bhb" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Kapan Loss Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box
                        style={{
                            textAlign: "center",
                            fontSize: "xx-large",
                            marginTop: "0.5rem",
                            width: "100%",
                        }}
                    >
                        Kapan Loss Details
                    </Box>
                    <Container maxWidth="xxl">
                        <Box
                            sx={{
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                height: "50vh",
                            }}
                        >
                            <DataGridPro
                                disableRowSelectionOnClick={true}
                                getRowHeight={() => "auto"}
                                sx={{
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "8px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "15px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "22px",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                                        width: "0.4em",
                                        height: "0.7em",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
                                        background: "#f1f1f1",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                                        backgroundColor: "#888",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
                                        background: "#555",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                slots={{ toolbar: GridToolbar }}
                                rows={rows}
                                columns={columns}
                                getRowId={(row) => row.id}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            // locationid: false,
                                            // id: false,
                                        },
                                    },
                                    sorting: {
                                        sortModel: [{ field: "updatedat", sort: "desc" }],
                                    },
                                }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                                {detailLoader ? (
                                    <CircularProgress size="1rem" />
                                ) : (
                                    <Tooltip title="Reload List">
                                        <RefreshOutlinedIcon
                                            onClick={() => handleSearch()}
                                            color="primary"
                                            fontSize="large"
                                            sx={{ cursor: "pointer", mr: 1 }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="error" onClick={close}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default KapanlosslistModal;
